import { useEffect, useState } from 'react';
import MemberType from '../MemberType';
import Button from '../Button';
import RadioButton from '../RadioButton';

export default function SelfTicket({
  title = 'John Doe',
  setIsForYou,
  setTickets,
  data,
  onNotForYou,
}) {
  const [forYou, setForYou] = useState(true);
  const [memberType, setMemberType] = useState('non-member');
  const [price, setPrice] = useState(0.0);

  const user = data?.user;

  useEffect(() => {
    if (!user) return;
    const level = user.user_membership_level || 'none';
    setMemberType(level === 'none' ? 'non-member' : level);
    const c = user.cost;
    setPrice(typeof c === 'string' || typeof c === 'number' ? Number(c) : 0);
  }, [user?.user_membership_level, user?.cost]);

  // If user data is missing we can't render the self-ticket form.
  if (!user) {
    return (
      <div className="ticket">
        <p className="ticket__body-error" role="alert">
          Unable to load your account information. Please refresh the page.
        </p>
      </div>
    );
  }

  const handleSubmit = () => {
    if (forYou) {
      setIsForYou(1);
      setTickets([
        {
          id: 'self-ticket',
          isSelf: true,
          first_name: user.first_name ?? '',
          last_name: user.last_name ?? '',
          member_type: memberType,
          price: Number(price),
          user_id: user.uid || null,
          company: user.company || '',
          title: user.title || '',
          email: user.email || '',
        },
      ]);
    } else {
      if (onNotForYou) {
        onNotForYou();
      } else {
        setIsForYou(2);
      }
    }
  };

  return (
    <div className="ticket">
      <div className="ticket__header">
        <div className="ticket__member">
          <h4>
            {user.first_name ?? ''} {user.last_name ?? ''}
          </h4>
          <MemberType type={memberType} />
        </div>
        <p>${price}</p>
      </div>
      <div className="ticket__body">
        <p>Is this ticket for you?</p>
        <div className="ticket__radio">
          <RadioButton
            id="forYouYes"
            name="forYou"
            checked={forYou}
            onChange={() => setForYou(!forYou)}
            label="Yes"
          />
          <RadioButton
            id="forYouNo"
            name="forYou"
            checked={!forYou}
            onChange={() => setForYou(!forYou)}
            label="No"
          />
        </div>
        <Button onClick={handleSubmit}>Next</Button>
      </div>
    </div>
  );
}
